import { readCookie } from '@/utils/cookie';

export const CONSENT_COOKIE = 'cookieconsent_status';

/**
 * Whether the visitor has agreed to non-essential cookies.
 *
 * Read from the cookie rather than the store so it is correct before the store
 * has hydrated, and so it agrees with the inline consent script in
 * public/index.html, which runs long before any of this.
 *
 * Undecided counts as no: the banner is still up, and silence is not agreement.
 *
 * @returns {boolean}
 */
export const hasAnalyticsConsent = () => readCookie(CONSENT_COOKIE) === '1';
